export enum MovementType {
  DoorToAirport = "Door-to-Airport",

  AirportToDoor = "Airport-to-Door",

  DoorToDoor = "Door-to-Door",

  AirportToAirport = "Airport-to-Airport",
}
